import React from 'react'
import { Card, Form, Button } from 'react-bootstrap'
import d_log from 'loglevel'

function Contact() {
  return (
    <div>
      <h1>Contact Us</h1>
      <Card className="mt-4">
        <Card.Body>
          <Card.Title>Get in Touch</Card.Title>
          <Card.Text>
            Have questions about DSRAG? We'd love to hear from you.
          </Card.Text>
          
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control type="text" placeholder="Enter your name" />
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" placeholder="Enter your email" />
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Subject</Form.Label>
              <Form.Control type="text" placeholder="Enter subject" />
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Message</Form.Label>
              <Form.Control as="textarea" rows={4} placeholder="Enter your message" />
            </Form.Group>
            
            <Button variant="primary" type="submit">
              Send Message
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  )
}

export default Contact